import { render, staticRenderFns } from "./returnGoodslistDialogNew.vue?vue&type=template&id=59c11ec4&scoped=true"
import script from "./returnGoodslistDialogNew.vue?vue&type=script&lang=js"
export * from "./returnGoodslistDialogNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c11ec4",
  null
  
)

export default component.exports